import {Box, Fade, Stack, Typography} from "@mui/material"


interface SlideDetailProps {
    title: React.ReactNode,
    subTitle: React.ReactNode,
    src: string,
}


const SlideDetail = ({title, subTitle, src}: SlideDetailProps) => {
    
    return (

        <Box
            sx={{
                height: '400px',
                width: 1,
                backgroundImage: `url(${src})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}
        >
            <Stack
                direction={'column'}
                justifyContent={'center'}
                alignItems={'center'}
                style={{
                    width: '100%',
                    height: '100%',
                    opacity: 1,
                    zIndex: 2,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }}
            >
                <Fade
                    timeout={{enter: 1200, exit: 0}}
                >
                    <div>
                        <Stack direction={'column'} alignItems={'center'} gap={1}>
                            <Typography
                                sx={{
                                    fontSize: '2.875rem', fontWeight: 900,
                                    textAlign: 'center', textTransform: 'uppercase', color: 'white'
                                }}
                                variant={'h4'}>
                                {title}
                            </Typography>
                            <Typography variant={'h6'}
                                        sx={{
                                            fontSize: '1.3125rem',
                                            textAlign: 'center', color: 'white'
                                        }}
                            >{subTitle}
                            </Typography>
                        </Stack>

                    </div>
                </Fade>
            </Stack>
        </Box>
    )
}

export default SlideDetail